<template>
  <fieldset class='lib__form__fieldset'>
    <legend class='lib__form__legend'>{{ $t('common.contact.person') }}</legend>
    <div class='lib__panel'>
      <h3 class='lib__panel__header'></h3>
      <button v-if='showRemoveButton' class='lib__panel__close' @click.prevent='remove'>
        <i class='far fa-trash-alt'></i>
      </button>
      <div class='lib__panel__main lib__panel__main--form'>
        <fieldset class='lib__form__fieldset'>
          <legend class='lib__form__legend'>{{ $t('common.contact.form.civility') }}</legend>
          <civility-selector v-model='value.civility' :data-vv-as="$t('common.contact.form.civility')"
                             name='civility'></civility-selector>
        </fieldset>
        <fieldset class='lib__form__fieldset'>
          <legend class='lib__form__legend'>{{ $t('common.contact.form.contactInformation') }}</legend>
          <div class='row'>
            <div class='col-xs-12 col-md-6'>
              <text-box v-model='value.firstName' :label="$t('common.contact.form.firstName')" required></text-box>
            </div>
            <div class='col-xs-12 col-md-6'>
              <text-box v-model='value.lastName' :label="$t('common.contact.form.lastName')" required></text-box>
            </div>
            <div class='col-xs-12 col-md-6'>
              <text-box v-model='value.job' :label="$t('common.contact.form.job')" :required='jobRequired'></text-box>
            </div>
            <div class='col-xs-12 col-md-6'>
              <text-box v-model='value.email' :label="$t('common.contact.form.email')" email required></text-box>
            </div>
            <div v-if='showBirthdate' class='col-xs-12 col-md-6'>
              <date-selector v-model='value.birthdate' :label="$t('common.contact.form.birthdate')"
                             required></date-selector>
            </div>
            <div class='col-xs-12 col-md-6'>
              <phone-box v-model='value.mobile' :label="$t('common.contact.form.mobile')"
                         :required="!value.phone || value.phone === '+32 '" gsm></phone-box>
            </div>
            <div class='col-xs-12 col-md-6'>
              <collapsable-phone-box v-model='value.phone'
                                     :addLabel="$t('common.contact.form.addPhone')"
                                     :label="$t('common.contact.form.phone')"
                                     :required="!value.mobile || value.mobile === '+32 '"></collapsable-phone-box>
            </div>
          </div>
        </fieldset>
        <fieldset class='lib__form__fieldset'>
          <legend class='lib__form__legend'>{{ $t('common.contact.form.address') }}</legend>
          <div class='row'>
            <div class='col-xs-12'>
              <address-form :required='isProtectedCustomerRequest' v-model='value.address'></address-form>
            </div>
          </div>
        </fieldset>
        <fieldset class='lib__form__fieldset' v-if='!isProtectedCustomerRequest'>
          <legend class='lib__form__legend'>{{ $t('common.contact.otherContactDescription') }}</legend>
          <ValidationProvider v-slot='{ errors, passed, failed }' :rules='{ required: true }' slim>
            <div :class="[failed && 'lib__field--error', passed && 'lib__field--valid']" class='lib__field'>
              <textarea v-model='value.description' class='lib__field__textarea'
                        data-vv-as='other-contact-description' name='other-contact-description' rows='5'></textarea>
              <error-message :error='errors[0]'></error-message>
            </div>
          </ValidationProvider>
        </fieldset>
      </div>
    </div>
  </fieldset>
</template>

<script lang='ts'>
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import AddressForm from '@/components/inputs/contact/AddressForm.vue'
import { ContactPerson } from '@/models'

@Component({
  name: 'contact-person-form',
  components: {
    AddressForm,
  },
})
export default class ContactPersonForm extends Vue {

  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly value!: ContactPerson
  @Prop({ type: Boolean, required: false, default: true }) public readonly showBirthdate!: boolean
  @Prop({ type: Boolean, required: false, default: true }) public readonly showRemoveButton!: boolean
  @Prop({ type: Boolean, required: false, default: true }) public readonly jobRequired!: boolean
  @Prop({ type: Boolean, required: false, default: false }) public readonly isProtectedCustomerRequest!: boolean
  //#endregion

  //#region [Emit]
  @Emit('remove')
  public remove(): void {
    return undefined
  }

  //#endregion
}
</script>
